<template>
  <div>
    <component :is="currentView" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentView: null,
    };
  },
  mounted() {
    this.checkDevice();
    window.addEventListener('resize', this.checkDevice); // 监听窗口变化
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkDevice); // 移除监听
  },
  methods: {
    checkDevice() {
      const isMobile = window.innerWidth <= 768; // 判断是否为移动设备
      if (isMobile) {
        import('@/views/yjbj_mobile.vue').then((module) => {
          this.currentView = module.default;
        });
      } else {
        import('@/views/yjbj_win.vue').then((module) => {
          this.currentView = module.default;
        });
      }
    },
  },
};
</script>